<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
        <v-card-title>Edit Notification Email Address</v-card-title>

        

        <v-card-text>
            <p>Emails will come from <code>bot@redchirp.com</code>.</p>
            <p><b>Make sure</b> that you have whitelisted <code>bot@redchirp.com</code> in your email client or your notifications will go to spam</p>
            <ul
                style="margin-bottom: 15px"
            >
                <li><a href="https://contenthacker.com/how-to-whitelist-in-gmail/" target="_blank">How to whitelist an email address in Gmail</a></li>
                <li><a href="https://blog.hubspot.com/marketing/email-whitelist" target="_blank">How to whitelist an email address in Gmail, Outlook, Yahoo and More</a></li>
            </ul>

            <p>Please note: RedChirp can not provide support for your email systems.  It is your responsibility to ensure that you have whitelisted <code>bot@redchirp.com</code></p>

            <v-text-field
                label="Label"
                v-model="label"
                autofocus
                autocomplete="off"
            />

            <v-text-field
                label="Email Address"
                v-model="email"
                autocomplete="off"
            />

            <v-select
                label="Mode"
                v-model="mode"
                :items="$rc.enumChoices('employee_notification_mode', false)"
            />

        </v-card-text>

        <v-card-actions>
            <v-btn
                text
                @click="onClickTest"
                :disabled="!is_valid"
            >
                Send Test Notification
            </v-btn>

            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
                :disabled="!is_valid"
            >
            Ok
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>
const Validation = require('@/js/validate.js');
export default {

    data() {
        return {
            dialog: false,
            label: null,
            email: null,
            mode: 'notify-anytime',
            index: -1,
        }
    },

    methods: {

        showDialog(device)
        {
            if ( device == null )
            {
                device = {
                    'index': -1,
                    'email': null,
                    'label': null,
                    'mode': 'notify-anytime',
                };
            }

            this.index = device.index;
            this.email = device.email;
            this.label = device.label;
            this.mode = device.mode;

            this.dialog = true;
        },

        onOk()
        {
            this.dialog = false;

            let device = {
                'index': this.index,
                'email': this.email,
                'label' : this.label.trim(),
                'mode' : this.mode,
            };

           this.$emit('ok', device);
        },

        onCancel()
        {
            this.dialog = false;
        },

        onClickTest()
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/employee-notifications/test-email',
            
                'params' : {
                        'email': this.email,
                    },
            
                'on_success': (data) => {

                        this.$rc.snackbar('Notification sent');
                    },
            
                'on_error': 'Unable to send test alert',
            });
        },

    },

    computed: {
        is_valid() {
            if ( this.label == null || this.label.trim().length == 0 ) return false;
            if ( this.email == null ) return false;
            if ( this.mode == null ) return false;

            return Validation.isEmailAddress(this.email);
        },
    },
}
</script>

<style lang="scss" scoped>
</style>